import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { OcbSftpVersion } from '@app/core';
import { TranslateService } from '@ngx-translate/core';
import { DxSelectBoxComponent } from 'devextreme-angular';

@Component({
  selector: 'app-sftp-version-picker',
  templateUrl: './sftp-version-picker.component.html',
  styleUrls: ['./sftp-version-picker.component.scss'],
})
export class SftpVersionPickerComponent {

    @Input()
    public selectedItem: string;

    @Output()
    public selectedItemChange = new EventEmitter<string>();

    @ViewChild(DxSelectBoxComponent)
    public selectBox: DxSelectBoxComponent;

    public sftpVersions: any[] = new Array<any>();
    public loading: boolean = true;

    public constructor(private translateService: TranslateService) {
        this.translateService.get('sftpVersions').subscribe(labels => {
            for (const version in OcbSftpVersion) {
                if (isNaN(Number(version))) {
                    this.sftpVersions.push({ name: labels[version], id: OcbSftpVersion[version] });
                }
            }
            this.loading = false;
        });
    }

    public onSelectedItemChange($event: { name: string, id: string }) {
        if ($event == null) {
            this.selectedItemChange.emit(null);
        } else {
            this.selectedItemChange.emit($event.id);
        }
    }
}
